var map = {
	"./ar/aboutUs/index.vue": [
		8920,
		8920
	],
	"./bn/aboutUs/index.vue": [
		8935,
		8935
	],
	"./en/aboutUs/index.vue": [
		2595,
		2595
	],
	"./fa/aboutUs/index.vue": [
		89,
		89
	],
	"./ur/aboutUs/index.vue": [
		1599,
		1599
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8934;
module.exports = webpackAsyncContext;